import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import {
  isLoggedIn,
  check_allowed_role,
  isServiceProvider,
  PLANT_USER,
} from "../../utils/AuthService";
import Header from "../../components/layouts/Header";
import Footer from "../../components/layouts/Footer";
import Sidebar from "./Sidebar";
import { chekAllPermissions } from "../../utils/permissons";

const DefaultLayout = ({
  permissionsRequired,
  rolesRequired = [PLANT_USER],
  isFeatureFlag,
}) => {
  if (!isLoggedIn()) {
    return <Navigate to="/login" />;
  }

  // Service providers should only access the provider portal
  if (isServiceProvider()) {
    return <Navigate to="/provider-portal" />;
  }

  const allowedByPermissions = permissionsRequired
    ? chekAllPermissions(permissionsRequired)
    : false;
  const allowedRole = check_allowed_role(rolesRequired);

  if (isFeatureFlag && !allowedByPermissions) {
    return <Navigate to="/orders" />;
  }

  if (!allowedByPermissions && !allowedRole) {
    return <Navigate to="/orders" />;
  }

  return (
    <div className="app">
      <Header />
      <div className="app-body">
        <Sidebar />
        <main className="main">
          <div className="container-fluid mt-2">
            <Outlet />
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default DefaultLayout;
